import React, { useState, useEffect } from "react";
import { StyleSheet, Text, View } from "react-native";
import ReactPlayer from "react-player";

const VideoPlayer = ({
  onProgress,
  playing = false,
  url = null,
  played,
  playbackRate,
  duration,
  muted,
  volume,
  onDuration,
  onReady,
  onPause,
  onPlay,
  onEnded,
  controls,
  cref,
}) => {
  const [layout, setLayout] = useState(null);

  const isYoutubeUrl = () => {
    if (url) {
      const hostname = new URL(url).hostname;
      return hostname.includes("youtube.com");
    }
    return false;
  };

  return (
    <View
      style={styles.container}
      onLayout={(e) => setLayout(e.nativeEvent.layout.width)}
    >
      <ReactPlayer
        ref={cref}
        width={"100%"}
        height={layout && "30em"}
        onProgress={(e) => {
          onProgress(e.playedSeconds);
        }}
        progressInterval={300}
        controls={isYoutubeUrl(url) ? true : controls}
        // controls={controls}
        onPlay={onPlay}
        onPause={onPause}
        onEnded={onEnded}
        stopOnUnmount
        muted={muted}
        volume={volume}
        onReady={onReady}
        onDuration={onDuration}
        played={played}
        playbackRate={playbackRate}
        duration={duration}
        playing={playing}
        url={url}
        config={{
          youtube: {
            preload: true,
            playerVars: {},
          },
          file: {
            forceHLS: url?.endsWith(".m3u8"),
            hlsOptions: {
              autoStartLoad: true,
              maxBufferLength: 40, // Increased buffer for smoother playback
              maxMaxBufferLength: 120, // Increased max buffer size
              liveSyncDuration: 10,
              liveMaxLatencyDuration: 15,
              capLevelOnFPSDrop: true,
              fragLoadingTimeOut: 20000,
              manifestLoadingTimeOut: 20000,
              lowLatencyMode: false,
              maxBufferHole: 1,
              maxFragLookUpTolerance: 0.5,
            },
          },
        }}
      />
    </View>
  );
};

export default VideoPlayer;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: "1.4rem",
    paddingVertical: "1.4rem",
  },
});
